export default __webpack_public_path__ + "static/media/PHÂN HỆ QUẢN LÝ DƯỢC- VẬT TƯ.7e394c95.pdf";